<template>
  <el-dialog title="查看查验信息" :visible.sync="visible" append-to-body v-dialogDrag width="900px" class="BoxRight"
    :close-on-click-modal="false">
    <el-form :model="form" status-icon ref="form" label-position="right" label-width="100px">
      <div class="FromTitleStyle">
        <div class="FromTitleBorder"></div>
        <div class="FromTitleText">车辆信息</div>
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="入场编号">
            <div class="text">{{ form.RegistrationNum | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车辆类型">
            <div class="text">
              {{ form.VehicleType | CodeName($g.VehicleType) }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="是否缺件" prop="IsMissParts">
            <div class="text">
              {{ form.IsMissParts | enumer("IsMissParts") }}
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="FromTitleStyle">
        <div class="FromTitleBorder"></div>
        <div class="FromTitleText">五大总成</div>
      </div>
      <el-row>
        <el-col :span="24">
          <el-form-item label="五大总成">
            <el-checkbox-group v-model="checkedCities" disabled>
              <el-checkbox v-for="city in cities" :label="city" :key="city">{{
                city
              }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="FromTitleStyle" v-if="form.MissParts">
        <div class="FromTitleBorder"></div>
        <div class="FromTitleText">缺失部件</div>
      </div>
      <el-row>
        <div v-for="(item1, index) in this.misspatrslist" :key="index">
          <el-col :span="6">
            <el-form-item label="缺失部件">
              <div class="text">{{ item1.partName | gang }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="数量">
              <div class="text">
                {{ item1.partNum | gang }}
              </div>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
          <el-form-item>
             {{ item1.partName }}:{{ item1.partNum }}
          </el-form-item>
        </el-col> -->
        </div>
      </el-row>
      <!-- <div v-show="this.form.IsProve == '1' ? true : false"> -->
      <div class="FromTitleStyle">
        <div class="FromTitleBorder"></div>
        <div class="FromTitleText">车辆照片</div>
      </div>

      <el-row>
        <el-col :span="8">
          <el-form-item label="整车照">
            <div class="demo-image__preview">
              <el-image style="width: 130px; height: 130px" :src="form.VehiclePhotoUrl"
                :preview-src-list="[form.VehiclePhotoUrl]">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车架号照片">
            <div class="demo-image__preview">
              <el-image style="width: 130px; height: 130px" :src="form.VinPhotoUrl"
                :preview-src-list="[form.VinPhotoUrl]">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- </div> -->
      <div class="FromTitleStyle">
        <div class="FromTitleBorder"></div>
        <div class="FromTitleText">特殊事项</div>
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="送达方式">
            <div class="text">{{ form.DeliveryMethod | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="铝圈个数">
            <div class="text">{{ form.AluminumRingNum | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="扣重扣杂(kg)">
            <div class="text">
              {{ form.BuckleWeight | gang }}
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
const cityOptions = ["车架", "发动机", "变速器", "前后桥", "方向机"];
export default {
  props: ["item"],
  components: {},
  data() {
    return {
      visible: false,

      form: {},
      checkedCities: [],
      misspatrslist: [],
      ismisspatrslist: false,
      cities: cityOptions,
    };
  },
  computed: {},
  watch: {
    item: {
      handler: function (v) {
        this.visible = true;
        this.$get("VehicleRegistration/GetItem", {
          KeyId: v.KeyId,
        }).then((r) => {
          if (r.Result.FiveMajorAssemblies) {
            this.checkedCities = JSON.parse(r.Result.FiveMajorAssemblies);
          }
          this.misspatrslist = [];
          if (r.Result.MissParts) {
            this.misspatrslist = JSON.parse(r.Result.MissParts);
          }
          this.form = { ...r.Result };
        });
      },
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
  margin-top: 10px;
  @include font_color("text-color2");
}
</style>
